export enum OverlayOpacity {
    TRANSPARENT,
    GRAY,
    COVERED,
    BLACK,
}

export const PORTAL_ZINDEX = 1000;